import type { PageModel, SurveyStore } from '@webapp/common/resources/entities';

import type { BundleEntity } from '@webapp/survey/src/entities/bundle';

export const withAuth = (ctx: SurveyStore): boolean => {
    const { individualPasswords, passwordAccess, vkAuth } = ctx.info.params.main;

    return individualPasswords || passwordAccess || vkAuth;
};

export const withSurveyTimer = (
    ctx: SurveyStore,
    bundles: Array<BundleEntity>,
    currentBundleIndex: number,
): boolean => {
    const { timer, timerOn } = ctx.info.params.main;

    if (timerOn && bundles && currentBundleIndex !== 0) {
        const allPrevBundlesQuestions = bundles
            .filter((_, idx) => idx < currentBundleIndex)
            .reduce((acc, b) => [...acc, ...b.questions], []);
        if (allPrevBundlesQuestions.length > 0) {
            const isStartTimer = allPrevBundlesQuestions.find((q) => {
                return String(timerOn) === String(q.getSnapshot().context.id);
            });
            if (isStartTimer) {
                return true;
            }
        }
    }
    return timer && !timerOn;
};

export const withRandomPages = (pages: Array<PageModel>): boolean => pages.some((p) => p.random);
